/** @jsx jsx */
import { jsx, Container, Flex } from "theme-ui";

interface TextSectionProps {
	title?: string;
	text?: string | JSX.Element;
	backgroundColor: string;
	textColor: string;
	buttonText?: string;
	buttonLink?: string;
	cta?: JSX.Element;
}

const TextSection = ({
	title,
	text,
	backgroundColor,
	textColor,
	buttonText,
	buttonLink,
	cta,
}: TextSectionProps) => {
	return (
		<section
			sx={{
				backgroundColor: backgroundColor,
				py: ["32px"],
				px: ["20px"],
			}}
		>
			<Container
			sx={{
				px: [0,null,null, null, null],
			}}
			>
				<Flex
					sx={{
						flexDirection: "column",
						variant: "text.p",
						color: textColor,
						textAlign: "center",
						alignItems: "center",
					}}
				>
					{title && (
				<h2
					sx={{
						fontWeight: "normal",
						color: textColor,
						mb: 3,
					}}
				>
					{title}
				</h2>
			)}

					{text && <p sx={{fontSize: [1,1,1,2], textAlign:"center", color: textColor }}>{text}</p>}

					{/* Call-to-action logic */}
					{buttonText && buttonLink ? (
						<a
							sx={{
								variant: "buttons.primary",
								width: "260px",
								mx: "auto",
								mt: 4
							}}
							href={buttonLink}
							target="_blank"
						>
							{buttonText}
						</a>
					) : (
						cta
					)}
				</Flex>
			</Container>
		</section>
	);
};

export default TextSection;
